import { INews } from "../models/INews";
import { makeAutoObservable } from "mobx";
import NewsService from "../service/NewsService";
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
} from "../components/toasts";

interface newsFilters {
  status: string[];
  states: string[];
}

export default class News {
  NewsList: INews[] = [];
  loadingNewsBool: boolean = false;
  newsFilters: newsFilters = {} as newsFilters;

  constructor() {
    makeAutoObservable(this);
  }

  setNewsList(eventList: INews[]) {
    this.NewsList = eventList;
  }

  setNewsFilter(status: string[]) {
    // this.newsFilters.states = states;
    this.newsFilters.status = status;
  }

  async loadList(page: number = 1) {
    this.loadingNewsBool = true;
    const NewsList = await NewsService.fetchList(
      this.newsFilters.status,
      // this.newsFilters.states,
      page
    );
    this.setNewsList(NewsList.data.result);
    this.loadingNewsBool = false;
    return NewsList.data;
  }

  async createOne(data: INews | undefined, page: number = 1) {
    this.loadingNewsBool = true;
    showLoadingToast("Creating news...");
    if (typeof data !== "undefined") {
      await NewsService.fetchCreateOne(data);
      await this.loadList(page);
      showSuccessToast("News created");
    } else {
      console.error("no data to send");
      showErrorToast("Error creating news");
    }
    this.loadingNewsBool = false;
  }

  async updateOne(data: INews | undefined, page: number = 1) {
    this.loadingNewsBool = true;
    showLoadingToast("Updating news...");
    if (typeof data !== "undefined") {
      await NewsService.fetchUpdateOne(data);
      await this.loadList(page);
      showSuccessToast("News updated");
    } else {
      console.log("no data to update");
      showErrorToast("Error updating news");
    }
    this.loadingNewsBool = false;
  }

  async deleteOne(data: INews | undefined, page: number = 1) {
    this.loadingNewsBool = true;
    if (typeof data !== "undefined") {
      await NewsService.fetchDeleteOne(data._id);
      await this.loadList(page);
    } else {
      console.error("no data to delete");
      showErrorToast("Error deleting news");
    }
    this.loadingNewsBool = false;
  }
}
